
import {ApiRequest} from "./request"
import {setupDropdown} from "./semantic-ui"
import commands from "./playground/commands"
import formElements from "./playground/form_elements"

export default function playground(app)
{
    function htmlEntities(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    async function playgroundRequest($form, btn)
    {
        const data = getFormData()
        let response = await ApiRequest($form.attr('action'), JSON.stringify(data))
        if (typeof response === 'string' || response instanceof String){
            response = JSON.parse(response)
        }

        $(document).find('#request-result').html(response.error ? '<span class="error">'+response.message+'</span>' : htmlEntities(response.data))
        btn.html('Send API Request')
        btn.prop('disabled', false)
    }

    async function sendResetApiKeyRequest(url, btn)
    {
        let response = await ApiRequest(url, {}, 'POST', 'application/json', 'application/json')
        const api_key = response.api_key ? response.api_key : false

        if(response.success){
            if(api_key){
                $('#api-key').html(api_key)
                $('input[name="api_key"]').val(api_key)
            }
        }
        btn.data('clicked', 0)
        btn.css('opacity', 1)
    }

    const addNewHeader = function (e) {
        $(e.target).prev('.headers-wrap').append(formElements.getHeaderRow())
    }

    const removeHeader = function (e) {
        $(e.target).parents('.form-group').remove()
    }

    const sendPlaygroundRequest = function (e)
    {
        e.preventDefault();
        const btn = $(e.target)

        btn.html('loading...')
        btn.prop('disabled', true)

        $('a[data-target="playground-code-samples"]').removeClass('active')
        $('a[data-target="playground-result"]').addClass('active')
        $('div[data-target-id="playground-code-samples"]').removeClass('active')
        $('div[data-target-id="playground-result"]').addClass('active')

        playgroundRequest($('#api-playground'), btn)
    }

    const saveDataToBuffer = function (val, e)
    {
        const btn = $(e.target)
        const btnName = btn.html()
        navigator.clipboard.writeText(val);

        btn.html('Copied!')
        setTimeout(() => {
            btn.html(btnName)
        }, 1500)
    }

    const resetApiKey = function (evt)
    {
        const el = $(evt.target)
        const url = el.data('url')
        const clicked = parseInt(el.data('clicked'))

        if(!clicked || clicked !== 1){
            el.data('clicked', 1)
            el.css('opacity', 0.55)
            sendResetApiKeyRequest(url, el);
        }
    }

    const numberFilter = function (evt)
    {
        if($(this).hasClass('.range-filter')){
            return true
        }

        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        return !(charCode > 31 && (charCode < 48 || charCode > 57))
    }

    const rangeFilter = function (evt)
    {
        evt = (evt) ? evt : window.event;
        let el = $(this),
            min = parseInt(el.attr('min')),
            max = parseInt(el.attr('max')),
            charCode = (evt.which) ? evt.which : evt.keyCode;

        if(min && el.val() < min && charCode !== 8){
            el.val(min)
            return false;
        }
        if(max && el.val() >= max-1){
            el.val(max)
            return false;
        }
    }

    const getFormData = function()
    {
        const $form = document.getElementById('api-playground')
        const formData = new FormData($form)
        const mode = $form.getAttribute('data-mode')

        let keys = []
        if(mode === 'scraping'){
            keys = [
                'url', 'method', 'render_js', 'keep_headers', 'device', 'proxy_type', 'wait_for', 'session', 'timeout',
                'country', 'api_key', 'extract_rules', 'wait_until', 'headers', 'body'
            ];

        }else if(mode === 'serp'){
            let google_keys = [
                'q', 'location', 'ludocid', 'lr', 'hl', 'gl', 'uule', 'google_domain', 'start', 'num', 'tbm', 'sort_by',
                'ijn', 'cookie', 'lsig', 'time_period', 'time_period_min', 'time_period_max', 'tbs', 'flatten_results',
                'safe', 'filter', 'nfpr', 'device', 'empty_results'
            ];
            let bing_keys = [
                'q', 'location', 'cc', 'offset', 'count', 'device', 'safeSearch', 'setLang', 'mkt'
            ];

            let yandex_keys = [
                'text', 'location', 'language', 'yandex_domain', 'lr', 'device', 'p'
            ];
            let google_scholar_keys = [
                'q', 'cites', 'cluster', 'as_ylo', 'as_yhi', 'scisbd', 'as_vis', 'lr', 'hl', 'safe', 'start', 'num'
            ];
            let google_scholar_profiles_keys = [
                'mauthors', 'after_author', 'before_author', 'hl'
            ];
            let google_scholar_cite_keys = [
                'q', 'device'
            ];
            let google_scholar_author_keys = [
                'author_id', 'sort', 'view_op', 'citation_id', 'start', 'num', 'hl', 'device'
            ];
            let google_product_keys = [
                'product_id', 'location', 'uule', 'google_domain', 'hl', 'gl', 'start', 'device'
            ];
            let google_reverse_image_keys = [
                'image_url', 'location', 'uule', 'google_domain', 'hl', 'gl', 'lr', 'device'
            ];
            let google_events_keys = [
                'q', 'location', 'device', 'uule', 'google_domain', 'hl', 'gl'
            ];
            let google_jobs_keys = [
                'q', 'location', 'uule', 'google_domain', 'hl', 'gl', 'start', 'device'
            ];
            let google_maps_keys = [
                'q', 'type', 'data', 'hl', 'google_domain', 'll'
            ];
            let google_maps_reviews_keys = [
                'q', 'location', 'device'
            ];
            let google_trends_keys = [
                'q', 'geo', 'cat', 'date'
            ];
            let google_play_keys = [
                'q', 'product_id', 'type', 'store', 'hl', 'gl'
            ];

            let common_keys = ['api_key', 'engine', 'url'];

            keys = [...new Set(
                google_keys.concat(bing_keys, yandex_keys, google_scholar_keys, google_scholar_profiles_keys,
                google_scholar_cite_keys, google_scholar_author_keys, google_product_keys, google_reverse_image_keys,
                google_events_keys, google_jobs_keys, google_maps_keys, google_maps_reviews_keys, google_trends_keys,
                google_play_keys, common_keys
                )
            )];
        }

        let object = {}
        formData.forEach(function(value, key){
            if(keys.includes(key)){
                if(key === 'cookie'){
                    value = encodeURIComponent(value)
                }
                object[key] = value
            }
        });

        return object
    }

    const updateCodeSample = function(event)
    {
        const apiUrl = document.getElementById('api-url').value
        const formData = getFormData()
        const httpMethod = formData.method ? formData.method.toUpperCase() : 'GET'
        const keys = ['api_key', 'method']

        let lang = typeof event.target !== 'undefined' && event.target.getAttribute('name') === 'lang'
            ? event.target.value
            : document.querySelector('input[name="lang"]:checked').value;
        let params = ''

        for (const key in formData) {
            if(formData[key] && !keys.includes(key)){
                let param = formData[key]
                if(key === 'url'){
                    param = encodeURIComponent(formData[key])
                }
                params += `&${key}=${param}`
            }
        }

        lang = lang.charAt(0).toUpperCase() + lang.slice(1)
        let code = commands[`get${lang}Command`](httpMethod, apiUrl, params)

        $('#code-sample').html(code)
    }

    const generateFields = function(e)
    {
        const $form = document.getElementById('api-playground')
        const engineEl = document.getElementById('engine')
        const mode = $form.getAttribute('data-mode')
        const fieldsWrapEl = $(document).find('#form-fields-wrap')
        const allFormElements = {
            ...formElements,
            ...window.serpFormElements
        }

        let fields = ''

        fieldsWrapEl.html('')

        if(mode === 'serp'){
            switch (engineEl.value) {
                case 'google':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getLudocidField()+
                        allFormElements.getLanguagesField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()+
                        allFormElements.getResultsLocationField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getOffsetField('start')+
                        allFormElements.getPerPageField()+
                        allFormElements.getSearchTypeField()+
                        allFormElements.getSortByField()+
                        allFormElements.getNumberOfImagesField()+
                        allFormElements.getCookiesField()+
                        allFormElements.getAdvancedGooglePlaceIDField()+
                        allFormElements.getTimePeriodField()+
                        allFormElements.getTimePeriodMinField()+
                        allFormElements.getTimePeriodMaxField()+
                        allFormElements.getTermBySearchField()+
                        allFormElements.getFlattenResultsField()+
                        allFormElements.getFilterAdultContentField()+
                        allFormElements.getFilterField()+
                        allFormElements.getExcludeAutocorrectedQueryField()+
                        allFormElements.getDeviceField()+
                        allFormElements.getEmptyResultsField()
                    break;
                case 'bing':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getBingCountriesField()+
                        allFormElements.getOffsetField()+
                        allFormElements.getPerPageField('count')+
                        allFormElements.getBingLanguagesField()+
                        allFormElements.getMarketField()+
                        allFormElements.getDeviceField()+
                        allFormElements.getSafeSearchField()
                    break;
                case 'yandex':
                    fields = allFormElements.getYandexQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getYandexLanguagesField()+
                        allFormElements.getYandexDomainField()+
                        allFormElements.getLanguagesLrField()+
                        allFormElements.getPageField()+
                        allFormElements.getDeviceField()
                    break;
                case 'google_scholar':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getCitesField()+
                        allFormElements.getClusterField()+
                        allFormElements.getFromYearField()+
                        allFormElements.getToYearField()+
                        allFormElements.getLanguagesLrField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getOffsetField('start')+
                        allFormElements.getPerPageField()+
                        allFormElements.getAbstractOnlyField()+
                        allFormElements.getCitationsField()+
                        allFormElements.getFilterAdultContentField()
                    break;
                case 'google_scholar_profiles':
                    fields = allFormElements.getGspQueryField()+
                        allFormElements.getAfterAuthorTokenField()+
                        allFormElements.getBeforeAuthorTokenField()+
                        allFormElements.getDisplayLanguagesField()
                    break;
                case 'google_scholar_cite':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getDeviceField()
                    break;
                case 'google_scholar_author':
                    fields = allFormElements.getAuthorIDField()+
                        allFormElements.getSortField()+
                        allFormElements.getViewOpField()+
                        allFormElements.getCitationIDField()+
                        allFormElements.getOffsetField('start')+
                        allFormElements.getPerPageField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getDeviceField()
                    break;
                case 'google_product':
                    fields = allFormElements.getProductIDField()+
                        allFormElements.getLocationField()+
                        allFormElements.getResultsLocationField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()+
                        allFormElements.getOffsetField('start')+
                        allFormElements.getDeviceField()
                    break;
                case 'google_reverse_image':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getImageURLField()+
                        allFormElements.getLocationField()+
                        allFormElements.getResultsLocationField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()+
                        allFormElements.getLanguagesLrField()+
                        allFormElements.getDeviceField()
                    break;
                case 'google_events':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getResultsLocationField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()+
                        allFormElements.getOffsetField('start')
                    break;
                case 'google_jobs':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getResultsLocationField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()+
                        allFormElements.getOffsetField('start')+
                        allFormElements.getDeviceField()
                    break;
                case 'google_maps':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getTypeField()+
                        allFormElements.getDataField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getGoogleDomainField()+
                        allFormElements.getLatitudeLongitudeField()
                    break;
                case 'google_maps_reviews':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getLocationField()+
                        allFormElements.getDeviceField()+
                        allFormElements.getDisplayLanguagesField()
                    break;
                case 'google_trends':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getCountriesField('geo')+
                        allFormElements.getCategoryField()+
                        allFormElements.getDateField()
                    break;
                case 'google_play':
                    fields = allFormElements.getQueryField()+
                        allFormElements.getProductIDField()+
                        allFormElements.getProductTypeField()+
                        allFormElements.getStoreField()+
                        allFormElements.getDisplayLanguagesField()+
                        allFormElements.getCountriesField()
                    break;
                default:
                    fields = allFormElements.getQueryField()
            }
        }

        fieldsWrapEl.append(fields)

        setupDropdown(fieldsWrapEl, app)
    }

    $(function()
    {
        /**
         * Updating of code examples
         */
        app.events.on('kx_dropdownSelect:engine', updateCodeSample)
        $(document).on('change', 'input[name="lang"], #api-playground input, #api-playground select', updateCodeSample)

        app.events.on('kx_dropdownSelect:tbm', function (event){
            const elem = $(event.el);
            let value =  elem.val();
            if(value === 'isch'){
                $('#ijn').closest('.panel-row').show();
            }else{
                $('#ijn').closest('.panel-row').hide();
                $('#ijn').val('');
            }
        })

        app.events.on('kx_dropdownSelect:time_period', function (event){
            const elem = $(event.el);
            let value =  elem.val();
            if(value === 'custom'){
                $('#time_period_min').closest('.panel-row').show();
                $('#time_period_max').closest('.panel-row').show();
            }else{
                $('#time_period_min').closest('.panel-row').hide();
                $('#time_period_max').closest('.panel-row').hide();
            }
        })

        /**
         * Search engine changing (fields generation)
         */
        $(document).on('change', '#engine', generateFields)

        /**
         * Filters for number only fields
         */
        $(document).on('keyup', '.number-filter.range-filter', rangeFilter)
        $(document).on('keypress', '.number-filter', numberFilter)

        /**
         * Reset api_key
         */
        $(document).on('click', '.widget-start-guide .reset-key', resetApiKey)

        /**
         * Playground request
         */
        $(document).on('click', '.send-api-request', sendPlaygroundRequest)

        /**
         * Add/remove headers fields
         */
        $(document).on('click', '#api-playground .add-header', addNewHeader)
        $(document).on('click', '#api-playground .form-group .close', removeHeader)

        /**
         * Copy text to a buffer
         */
        $(document).on('click', '.copy-btn-wrap #copy-btn', e => saveDataToBuffer($('#code-sample').text(), e))
        $(document).on('click', '.api-playground .copy-wrap', e => saveDataToBuffer($(e.target).parent().find('#api-url').val(), e))
        $(document).on('click', '.widget-start-guide .copy-wrap', e =>saveDataToBuffer($(e.target).parent().find('input[name="api_key"]').val(), e))
    })
}
